import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IAccountRetrievalVerifyOTPUseCase {
    execute(apiKey: string, identityToken: string, otp: string): Promise<any>;
}

export class AccountRetrievalVerifyOTPUseCase implements IAccountRetrievalVerifyOTPUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, identityToken: string, otp: string): Promise<any> {
        const result = await this.profileRepository.accountRetrievalVerifyOTP(apiKey, identityToken, otp);
        return result.data;
    }
}
